import { OperationLogsResponse } from '@/client/operation-log/types/operation-log.type';
import { AxiosInstance } from 'axios';

export const operationLogService = (client: AxiosInstance) => {
  const getOperationLogs = async (
    accountId: string,
  ): Promise<OperationLogsResponse> => {
    const { data } = await client.get<OperationLogsResponse>(
      `/accounts/${accountId}/operation-logs`,
    );

    return data;
  };

  return {
    getOperationLogs,
  };
};
